export const NEOVARSITY_MANAGEMENT_STATUS_TABS = [
  {
    name: 'Pending',
    to: 'projects/pending',
  },
  {
    name: 'Submitted',
    to: 'projects/submitted',
  },
];
